import { Box, Text } from "@chakra-ui/layout";
import { useCurrentAuth } from "features/auth/auth.store";
import { useCurrentTenant } from "features/auth/tenant.store";
import { TenantMePaiResponse } from "features/auth/typings/user";
import colors from "core/resources/theme/colors";
import { useMemo } from "react";

function TenantList({ search }: { search: string }) {
  const { auth } = useCurrentAuth();

  const items = useMemo(() => {
    if (!auth || !auth.tenants?.length) {
      return [];
    }

    let tenants = auth.tenants ?? [];

    const pais = tenants.filter((item) => !item.tenantPai);

    const children = tenants.filter((item) => !!item.tenantPai);

    const addedPaisIds: Record<string, 1> = {};
    const tenantsPaiSemPermissao: {
      id: string;
      nome: string;
      semPermissao: true;
    }[] = [];

    children.forEach((child) => {
      if (child.tenantPai && !addedPaisIds[child.tenantPai.id]) {
        addedPaisIds[child.tenantPai.id] = 1;
        tenantsPaiSemPermissao.push({ ...child.tenantPai, semPermissao: true });
      }
    });

    const mappedPaisComPermissao = pais.map((pai) => ({
      ...pai,
      items: search
        ? children.filter(
          (child) =>
            child.tenantPai?.id === pai.id &&
            child.nome.toLowerCase().includes(search.toLowerCase())
        )
        : tenants.filter((child) => child.tenantPai?.id === pai.id),
    }));

    const mappedPaisSemPermissao = tenantsPaiSemPermissao
      .filter((item) => !mappedPaisComPermissao.find((p) => p.id === item.id))
      .map((pai) => ({
        ...pai,
        items: search
          ? children.filter(
            (child) =>
              child.tenantPai?.id === pai.id &&
              child.nome.toLowerCase().includes(search.toLowerCase())
          )
          : tenants.filter((child) => child.tenantPai?.id === pai.id),
      }));

    const mappedPais = [...mappedPaisComPermissao, ...mappedPaisSemPermissao];

    let filteredPais = mappedPais;

    if (search) {
      filteredPais = mappedPais.filter(
        (pai) =>
          pai.nome.toLowerCase().includes(search.toLowerCase()) ||
          !!pai.items.find((child) =>
            child.nome.toLowerCase().includes(search.toLowerCase())
          )
      );
    }

    return filteredPais;
  }, [auth, search]);

  if (!auth || !auth.tenants?.length) {
    return null;
  }

  return (
    <>
      {items.map((item, key) => (
        <TenantListItem key={key} item={item} />
      ))}
    </>
  );
}

function TenantListItem({
  item,
}: {
  item: Partial<TenantMePaiResponse & { semPermissao?: true }>;
}) {
  const { tenant, selecionar: selecionarTenant } = useCurrentTenant();

  return (
    <>
      <Box
        onClick={
          item.semPermissao
            ? undefined
            : () => {
              selecionarTenant(item as TenantMePaiResponse);

              if (item.finishOnboardingDate === null) {
                setTimeout(() => {
                  window.location.href = "/onboarding/primeiro-passo";
                }, 500);
              } else {
                setTimeout(() => {
                  window.location.href = "/";
                }, 500);
              }
            }
        }
        color={item.semPermissao ? colors.gray : colors.primary}
        fontWeight={item.tenantPai ? "normal" : "bold"}
        cursor="pointer"
        bg={tenant?.id === item.id ? colors.blue100 : "transparent"}
        _hover={item.semPermissao ? undefined : { bg: "#f7f7f7" }}
        py="8px"
        pl={item.tenantPai ? "16px" : "8px"}
      >
        {item.nome}
        {item.items?.length && item.items.length > 0 ? (
          <Text
            color="#444"
            lineHeight={"10px"}
            fontWeight={"bold"}
            fontSize={"10px"}
          >
            {item.tipoTenant}
          </Text>
        ) : null}
      </Box>
      {item.items?.map((submenu, key) => (
        <TenantListItem item={submenu as any} key={key} />
      ))}
    </>
  );
}

export default TenantList;
